import React from 'react';
import * as ReactDOM from 'react-dom/client';
import type { GatsbyBrowser } from 'gatsby';

import { GlobalStateProvider } from './src/context/global';
import { AppProvider } from './src/context/appProvider';

import '@styles/global.css';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => (
    <AppProvider>{ element }</AppProvider>
);

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => (
    <GlobalStateProvider>{ element }</GlobalStateProvider>
);

export const replaceHydrateFunction = () => {
    return (element: any, container: any) => {
        ReactDOM.createRoot(container)
                .render(element);
    };
};
